import React, { useEffect, useState } from 'react';
import { ClipLoader } from "react-spinners";
import "bootstrap/dist/css/bootstrap.min.css";
import { API_BASE_URL, ENDPOINTS } from './config';

function UsersPage() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${API_BASE_URL}/users`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });

                if (response.status === 403 || response.status === 401) {
                    alert("Session expired. Please log in again.");
                    localStorage.removeItem("token");
                    localStorage.removeItem("user");
                    window.location.href = "/";
                    return;
                }

                if (!response.ok) throw new Error('Failed to fetch users');
                const data = await response.json();
                setUsers(data);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();
    }, []);

    // 🔴 Logout function
    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        alert("You have been logged out.");
        window.location.href = "/";
    };

    if (loading) return (
        <div className="spinner-container">
                <ClipLoader color="#4fa94d" size={50} />
                <p>Loading users...</p>
            </div>
    );
    if (error) return <p>Error: {error}</p>;

    return (
        <div>
            <button onClick={handleLogout} style={{ marginBottom: "20px", padding: "10px", cursor: "pointer" }}> Logout </button>

            <table border="1">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user) => (
                        <tr key={user.user_id}>
                            <td>{user.user_id}</td>
                            <td>{user.first_name}</td>
                            <td>{user.email}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default UsersPage;